module.exports = __webpack_public_path__ + "media/hello.d3a13783.mp3";